import React from 'react';
import styled from 'styled-components';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';

const MiniCartContainer = styled.div`
  position: fixed;
  right: 32px;
  bottom: 32px;
  width: 340px;
  background: #fffbe6;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  border-radius: 16px;
  z-index: 2000;
  padding: 1.2rem 1.5rem 1.5rem 1.5rem;
  display: flex;
  flex-direction: column;
`;
const Title = styled.div`
  font-size: 1.15rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;
const CartList = styled.div`
  max-height: 180px;
  overflow-y: auto;
  margin-bottom: 1rem;
`;
const CartItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.7rem;
`;
const ItemInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.7rem;
`;
const ItemImage = styled.img`
  width: 36px;
  height: 36px;
  object-fit: contain;
  border-radius: 6px;
`;
const ItemName = styled.div`
  font-size: 0.98rem;
  font-weight: 500;
`;
const ItemWeight = styled.div`
  color: #888;
  font-size: 0.92rem;
`;
const ItemPrice = styled.div`
  font-weight: 700;
  color: #FF6B00;
  min-width: 48px;
  text-align: right;
`;
const Quantity = styled.div`
  font-size: 0.98rem;
  color: #333;
  margin-left: 0.5rem;
`;
const Total = styled.div`
  text-align: right;
  font-size: 1.08rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;
const CheckoutButton = styled.button`
  width: 100%;
  background: #006400;
  color: white;
  border: none;
  padding: 0.8rem 0;
  border-radius: 8px;
  font-size: 1.05rem;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
  &:hover { background: #004d00; }
`;
const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 12px;
  background: none;
  border: none;
  font-size: 1.3rem;
  color: #888;
  cursor: pointer;
`;

export default function MiniCart({ open, onClose }) {
  const { cart } = useCart();
  const navigate = useNavigate();
  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  if (!open || cart.length === 0) return null;

  return (
    <MiniCartContainer>
      <CloseButton onClick={onClose} title="Închide">×</CloseButton>
      <Title>Coșul tău</Title>
      <CartList>
        {cart.map(item => (
          <CartItem key={item.name + item.weight}>
            <ItemInfo>
              <ItemImage src={item.image} alt={item.name} />
              <div>
                <ItemName>{item.name}</ItemName>
                <ItemWeight>{item.weight} g</ItemWeight>
              </div>
            </ItemInfo>
            <Quantity>x{item.quantity}</Quantity>
            <ItemPrice>{(item.price * item.quantity).toFixed(2)} LEI</ItemPrice>
          </CartItem>
        ))}
      </CartList>
      <Total>Total: {total.toFixed(2)} LEI</Total>
      <CheckoutButton onClick={() => navigate('/checkout')}>Oferă comanda</CheckoutButton>
    </MiniCartContainer>
  );
}